import React from "react";
import { Anchor, HoverCard } from "@mantine/core";

const InlineChromiumBugfix = () => (
  <span
    contentEditable={false}
    // className={css`
    //   font-size: 0;
    // `}
  >
    {String.fromCodePoint(160) /* Non-breaking space */}
  </span>
);

const LinkComponent = ({ attributes, children, element }) => {
  return (
    <>
      <HoverCard
        width={"fit-content"}
        shadow="md"
        openDelay={500}
        radius={6}
        position={"bottom-start"}
      >
        <HoverCard.Target>
          <a {...attributes} href={element.url}>
            <InlineChromiumBugfix />
            {children}
            <InlineChromiumBugfix />
          </a>
        </HoverCard.Target>
        <HoverCard.Dropdown>
          <Anchor href={element.url} color={"dimmed"} size={"md"} w={"100%"}>
            {element.url}
          </Anchor>
        </HoverCard.Dropdown>
      </HoverCard>
    </>
  );
};

export default LinkComponent;
